module.exports = {"110102001":"西长安街街道","110102003":"新街口街道","110102007":"月坛街道","110102009":"展览路街道","110102010":"德胜街道","110102011":"金融街街道","110102012":"什刹海街道","110102013":"大栅栏街道","110102014":"天桥街道","110102015":"椿树街道","110102016":"陶然亭街道","110102017":"广安门内街道","110102018":"牛街街道","110102019":"白纸坊街道","110102020":"广安门外街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/110102.json
// module id = 23
// module chunks = 0